import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import HomepageContentForm from "./HomepageContentForm";
import { useGetHomePageDetailsQuery } from "../../../../store/services/HomePageContentService";

function HomepageContent() {
  const { data: pageDetails, error, isLoading } = useGetHomePageDetailsQuery();

  console.log("details =======>", pageDetails?.data);

  return (
    <section className="setting position-relative py-3">
      <Container>
        <Row className="justify-content-center">
          <Col lg="12">
            <h4 className="mb-0 py-3 fw-bold themeBlue text-capitalize">
              Home page content
            </h4>
          </Col>

          {isLoading && (
            <div className="text-center">
              <div className="spinner-border text-dark" >
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          )}
          {!isLoading && <HomepageContentForm data={pageDetails?.data} />}
        </Row>
      </Container>
    </section>
  );
}

export default HomepageContent;
